import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Loader from '../../../common/ui/Loader';
import ReactTable from 'react-table';
import { getColumnWidth } from '../../../../helpers/general';

export default class Contacts extends PureComponent {
  state = {
    isLoading: true
  };

  columnRenderer = () => {
    const data = this.props.company.contacts;

    return [
      {
        Header: 'Id',
        accessor: 'id',
        Cell: props => {
          const { id } = props.original;
          return (
            <Link className='badge badge-primary' to={`/app/employers/${id}`}>
              {id}
            </Link>
          );
        },
        width: 70
      },
      {
        Header: 'First Name',
        accessor: 'first_name',
        width: getColumnWidth(data, 'first_name', 'First Name')
      },
      {
        Header: 'Last Name',
        accessor: 'last_name',
        width: getColumnWidth(data, 'last_name', 'Last Name')
      },
      {
        Header: 'Email',
        accessor: 'email',
        Cell: props => {
          const { email } = props.original;
          return (
            <a href={`mailto:${email}`} className='link-primary'>
              {email}
            </a>
          );
        },
        width: getColumnWidth(data, 'email', 'Email')
      },
      {
        Header: 'Phone',
        accessor: 'phone',
        Cell: props => {
          const { phone } = props.original;
          return (
            <a href={`tel:${phone}`} className='link-primary'>
              {phone}
            </a>
          );
        },
        width: getColumnWidth(data, 'phone', 'Phone')
      }
    ];
  };

  _setDataLoaded = () => this.setState({ isLoading: false });

  componentDidMount () {
    this.props.getCompanyContacts(this.props.match.params.id)
      .then(this._setDataLoaded);
  }

  render () {
    if (this.state.isLoading) {
      return <Loader />;
    }

    const { company: { contacts } } = this.props;

    return contacts.length ? (
      <ReactTable
        noDataText={'No contacts found'}
        data={contacts}
        minRows={5}
        filterable
        columns={this.columnRenderer()}
        showPagination={false}
      />
    ) : (
      <div className='alert alert-info alert-static'>No contacts found.</div>
    );
  }
}

Contacts.propTypes = {
  company: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/app/companyDetails/Tabs/Contacts.js